import { COMPOSITION_ACTIVITY_BREAKDOWN_V3 } from '@revelio/data-access';

import { FilterId } from '../../../../../filters/types/filters';
import {
  ACTIVITY_LEVEL_ID_TO_FILTER_KEY,
  getEntKindForActivityLevelId,
} from '../../../../../filters/utils/role-skill-ent-kind';
import { levelIdsByNumber } from './level-ladder';
import type { IcicleTaxonomy } from './types';

const ACTIVITY_LEVEL_IDS = Object.keys(ACTIVITY_LEVEL_ID_TO_FILTER_KEY);

const ACTIVITY_ICICLE_TREE_LEVELS = [3, 4, 5, 6];

export const activityIcicleTaxonomy: IcicleTaxonomy = {
  segment: 'activities',
  filterId: FilterId.ACTIVITY,
  overlapping: true,
  query: COMPOSITION_ACTIVITY_BREAKDOWN_V3,
  breakdownLevelField: 'activity_breakdown_level',
  topNField: 'activities_top_n',
  tree: { kind: 'activity', levels: ACTIVITY_ICICLE_TREE_LEVELS },
  levelIds: (treeLevels) =>
    levelIdsByNumber(
      treeLevels,
      ACTIVITY_ICICLE_TREE_LEVELS,
      ACTIVITY_LEVEL_IDS
    ),
  rankedLevelIds: ACTIVITY_LEVEL_IDS,
  entKind: getEntKindForActivityLevelId,
};
